/* global console */
import { ElaborationStatusItem } from "../redux/feature/object/remote-elaborations-slice";
import NotificationManager from "../common/notification/NotificationManager";
import { DOWNLOAD_NOTIFICATION } from "../utils/constants/notification";
import { saveAs } from "file-saver";
import { formatMessage } from "../utils/helpers/LanguageHelper";

interface ElabResultObj {
  base64Content: string; // base64
  fileName: string;
}

function saveFile(file: ElabResultObj) {
  if (!file) return;

  const mime = "application/vnd.openxmlformats-officedocument.wordprocessingml.document";
  const base64StringFile = `data:${mime};base64,${file.base64Content}`;

  saveAs(base64StringFile, file.fileName);
}

export async function handleDownloadCopyElabResult(item: ElaborationStatusItem) {
  if (!item.messages.length) return;

  const file = JSON.parse(item.messages[0].details) as ElabResultObj;

  if (item.status === "COMPLETED" && file) {
    saveFile(file);

    NotificationManager.addNotification({
      key: DOWNLOAD_NOTIFICATION,
      message: formatMessage("cof.downloadcopy.success"),
      title: null,
      type: "success",
      closable: true,
      removeOnClose: true,
      isTemporary: true,
    });

    return;
  }

  NotificationManager.addNotification({
    key: DOWNLOAD_NOTIFICATION,
    message: formatMessage("cof.downloadcopy.error"),
    title: null,
    type: "error",
    closable: true,
    removeOnClose: true,
    isTemporary: true,
  });
  console.error("Error Saving File", item.messages);
}
